function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.string.starts-with.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import get from 'lodash/get';
export default {
  name: 'CoreView',
  props: {
    pageTitle: {
      type: Object,
      required: true
    },
    themes: {
      type: Object,
      required: true
    },
    footerData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      isThemeLoadingDone: false
    };
  },
  metaInfo: function metaInfo() {
    var pageTitle = this.pageTitle;
    var language = this.language;
    return {
      // title: this.$store.state.app.pageTitle[this.language],
      titleTemplate: function titleTemplate() {
        return pageTitle[language];
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['language', 'UiTheme', 'CustomTheme', 'mode'])), {}, {
    footer: function footer() {
      if (get(this.$route, 'meta.hideLayout') || this.footerData.hide) {
        return false;
      }
      return this.$route.name !== 'Maps' && this.$route.path !== '/error';
    },
    fillHeight: function fillHeight() {
      return this.$route.path === '/error' ? 'fill-height' : '';
    },
    id: function id() {
      if (get(this.$route, 'meta.hideLayout') && get(this.$route, 'meta.fullHeight') === false) {
        return '';
      }
      if (get(this.$route, 'meta.hideLayout') && get(this.$route, 'meta.fullHeight') === true) {
        return 'full-height-view';
      }
      return this.$route.path !== '/login' && this.$route.path !== '/error' && this.$route.path !== '/reset-password' && this.$route.path !== '/change-password' && this.$route.path !== '/oauth' && this.$route.path !== '/' ? 'core-view' : '';
    },
    backgroundStyle: function backgroundStyle() {
      var isPublicDashboard = this.$route.path.startsWith('/public');
      var isFavoritesPage = this.$route.path.startsWith('/home');
      var useCustomBackground = this.$store.state.app.useCustomBackground;

      // public dashboard will always be white
      if (isPublicDashboard) {
        return 'background-color: #fff;';
      }
      var mode = this.UiTheme ? 'dark' : 'light';

      // if useCustomBackground is set and its the favorites page then use the custom theme
      if (isFavoritesPage && useCustomBackground) {
        var gradient = mode === 'dark' ? 'linear-gradient(rgba(50, 50, 50, 0.98), rgba(50, 50, 50, 0.85))' : 'linear-gradient(rgba(240, 240, 240, 0.98), rgba(240, 240, 240, 0.8))';
        if (this.themes) {
          return "background-image: ".concat(gradient, ", url(").concat(this.themes[mode].background, "); background-size: cover;");
        } else {
          return "background-image: ".concat(gradient, "; background-size: cover;");
        }
      }

      // otherwise use default colors for the theme mode
      return "background-color: ".concat(mode === 'light' ? '#E5E5E5' : '#2d2d2d', ";");
    }
  })
};